import { createPortal } from "react-dom";
import { Button, Modal } from "@axismaxlife/unified-ui-components-library";
import { ImageLibrary } from "../constants/ImageLibrary";

export const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure you want to delete this entry?",
  cancelLabel = "Cancel",
  deleteLabel = "Delete",
}) => {
  if (!isOpen) return null;

  const modalElement = (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      device="mobile"
      variant="alert"
      alertState="error"
      icon={
        <img
          src={ImageLibrary.CROSS_RED}
          alt="cross_red"
          style={{ width: "24px", height: "24px", display: "block" }}
        />
      }
      title={title}
      bodyText=""
      showCloseIcon={false}
      buttonGroup="horizontal"
      buttons={[
        <Button key="cancel" buttonType="neutralLink" onClick={onClose}>
          {cancelLabel}
        </Button>,
        <Button key="delete" buttonType="primary" onClick={onConfirm}>
          {deleteLabel}
        </Button>,
      ]}
    />
  );

  return typeof document !== "undefined"
    ? createPortal(modalElement, document.body)
    : modalElement;
};

export default DeleteConfirmationModal;
